// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type QuestionMark24CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const QuestionMark24Circle: FC<QuestionMark24CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="32"
            height="32"
        >
            <path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Zm-1.037-14.913C14.72 17.68 14.6 18.65 14.6 20h2.875c0-.983.087-1.68.262-2.087.176-.409.671-1.005 1.488-1.788.767-.75 1.33-1.42 1.688-2.012.358-.592.537-1.305.537-2.138 0-1.367-.47-2.537-1.412-3.512C19.096 7.488 17.75 7 16 7c-1.417 0-2.592.392-3.525 1.175-.933.783-1.575 1.708-1.925 2.775l2.575 1.1c.183-.533.496-1.058.938-1.575C14.504 9.958 15.15 9.7 16 9.7c.817 0 1.454.225 1.913.675.458.45.687 1.017.687 1.7 0 .567-.18 1.07-.538 1.513-.358.441-.879.962-1.562 1.562-.783.7-1.296 1.346-1.537 1.937Zm-.375 8.326c.391.391.862.587 1.412.587.55 0 1.02-.196 1.413-.587.391-.392.587-.863.587-1.413s-.196-1.02-.587-1.413A1.926 1.926 0 0 0 16 22c-.55 0-1.02.196-1.412.587A1.926 1.926 0 0 0 14 24c0 .55.196 1.02.588 1.413Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default QuestionMark24Circle;
